import {useRef} from 'react';

import {isNil} from 'ramda';

import type {ApiError} from 'shared/web';

import {useLazyListBulkUserOptionsQuery} from './api';
import type {BulkUserOption} from './types';

export function useBulkUserOptions(onError: (error: ApiError) => void) {
  const [loadUsers] = useLazyListBulkUserOptionsQuery();
  const loadedOptions = useRef(new Map<string, BulkUserOption>());
  const loadOptions = (search: string) =>
    loadUsers({search})
      .unwrap()
      .then((options) => {
        options.forEach((option) => loadedOptions.current.set(option.value, option));
        return options;
      })
      .catch((error: ApiError) => {
        onError(error);
        return [];
      });
  const loadLabels = (values: string[]) =>
    Promise.resolve(
      values.flatMap((value) => {
        const option = loadedOptions.current.get(value);
        return isNil(option) ? [] : [option];
      })
    );

  return {loadOptions, loadLabels};
}
